import { Close as CloseIcon } from "@mui/icons-material";
import {
	Box,
	Button,
	Drawer,
	FormControl,
	IconButton,
	MenuItem,
	Select,
	TextField,
	Typography,
} from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { format } from "date-fns";
import ptBR from "date-fns/locale/pt-BR";
import { useEffect, useState } from "react";
import { MIDIA_OPTIONS_TELEFONIA_CANAL_DIRETO } from "../../constants/midia";

const SidebarPhoneFormCanalDireto = ({
		open,
		onClose,
		handleSubmit,
		budgetInfo,
		statusOptions,
	}) => {
	
	const [observacoes, setObservacoes] = useState("");
	const [selectedStatus, setSelectedStatus] = useState(0);
	const [dtRetorno, setDtRetorno] = useState("");
	const [selectedMidia, setSelectedMidia] = useState(0);

	const midiaOptions = MIDIA_OPTIONS_TELEFONIA_CANAL_DIRETO;

  useEffect(() => {
    const dt_retorno = new Date();
    setDtRetorno(budgetInfo.dt_retorno ? new Date(budgetInfo.dt_retorno) : dt_retorno);

    setObservacoes(budgetInfo.observacoes || "");
    setSelectedStatus(budgetInfo.id_status || 0);

  }, [budgetInfo]);

	const handleSubmitPhoneForm = (e) => {
		e.preventDefault();

		handleSubmit({
			selectedStatus,
			observacoes,
			dtRetorno: dtRetorno ? format(dtRetorno, "dd/MM/yyyy") : null,
			selectedMidia
		});
		onClose();
	};

	const labelStyle = {
		fontWeight: 500,
		letterSpacing: "0.05em",
		color: "#172b4d",
	};	

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      variant="persistent"
      container={document.getElementById("card-details")}
      sx={{
        "& .MuiDrawer-paper": {
          height: "85%",
          mt: "5%",
          border: "1px solid black",
          borderRight: "none",
          borderRadius: "8px 0px 0px 8px",
        },
      }}
    >
      <Box
        sx={{
          width: 350,
          p: 3,
          display: "flex",
          flexDirection: "column",
          gap: 2,
          justifyContent: "space-between",
          height: "100%",
        }}
        component="form"
        onSubmit={handleSubmitPhoneForm}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Typography variant="h4">Cadastro Retorno</Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
			<FormControl required>
				<Typography variant="caption" sx={labelStyle}>
					Data de Retorno
				</Typography>
				<LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
				<DatePicker
					inputFormat="dd/MM/yyyy"
					value={dtRetorno || null}
					onChange={(newDate) => setDtRetorno(newDate)}
					renderInput={(params) => <TextField {...params} />}
				/>
				</LocalizationProvider>
			</FormControl>

			<FormControl required>
				<Typography variant="caption" sx={labelStyle}>
					Motivo
				</Typography>
				<TextField
				select
				value={selectedStatus}
				onChange={(e) => setSelectedStatus(e.target.value)}
				SelectProps={{ native: true }}
				>
				<option value={0}>Selecione um status</option>
				{statusOptions.map((item) => (
					<option key={item.id} value={item.id}>
					{item.ds_status}
					</option>
				))}
				</TextField>
			</FormControl>

			<FormControl required>
				<Typography variant="caption" sx={labelStyle}>
					Mídia
				</Typography>
				<Select
					labelId="midia-label"
					value={selectedMidia}
					onChange={e => setSelectedMidia(e.target.value)}
					sx={{
						fontWeight: !selectedMidia ? 600 : 500,
						fontFamily: 'Montserrat',
					}}
				>
					<MenuItem
						value={0}
						sx={{
							fontWeight: 600,
							fontFamily: 'Montserrat',
						}}
					>
						Selecione uma mídia
					</MenuItem>
					{midiaOptions.map(midia => (
						<MenuItem
							key={midia.id}
							value={midia.ds_midia}
							sx={{
								fontWeight: 500,
								fontFamily: 'Montserrat',
							}}
						>
							{midia.ds_midia}
						</MenuItem>
					))}
				</Select>
			</FormControl>
			<FormControl>
				<Typography variant="caption" sx={labelStyle}>
					Observações
				</Typography>
				<TextField
					fullWidth
					multiline
					minRows={2}
					value={observacoes}
					onChange={(e) => setObservacoes(e.target.value)}
				/>
			</FormControl>
        </Box>

        <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
          <Button variant="outlined" onClick={onClose}>
            Cancelar
          </Button>
          <Button
            type="submit"
            variant="contained"
            disabled={!selectedStatus || !dtRetorno || selectedMidia === 0}
          >
            Salvar
          </Button>
        </Box>
      </Box>
    </Drawer>
  );
};

export default SidebarPhoneFormCanalDireto;
